(() => {
  class RhdScrollRail extends HTMLElement {
    connectedCallback() {
      if (this.dataset.railReady === 'true') return;

      this.dataset.railReady = 'true';
      this.track = this.querySelector('[data-rail-track]');
      this.previousButton = this.querySelector('[data-rail-previous]');
      this.nextButton = this.querySelector('[data-rail-next]');

      if (!this.track) return;

      this.abortController = new AbortController();
      const signal = this.abortController.signal;

      this.previousButton?.addEventListener('click', () => this.move(-1), { signal });
      this.nextButton?.addEventListener('click', () => this.move(1), { signal });
      this.track.addEventListener('scroll', () => this.queueUpdate(), { passive: true, signal });

      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(() => this.queueUpdate());
        this.resizeObserver.observe(this.track);
      }

      this.queueUpdate();
    }

    disconnectedCallback() {
      this.abortController?.abort();
      this.resizeObserver?.disconnect();
      if (this.animationFrame) window.cancelAnimationFrame(this.animationFrame);
      this.animationFrame = null;
      delete this.dataset.railReady;
    }

    move(direction) {
      const firstCard = this.track.firstElementChild;
      const styles = window.getComputedStyle(this.track);
      const gap = Number.parseFloat(styles.columnGap || styles.gap) || 0;
      const cardWidth = firstCard?.getBoundingClientRect().width || this.track.clientWidth * 0.8;
      const isRtl = document.documentElement.dir === 'rtl';
      const left = (cardWidth + gap) * direction * (isRtl ? -1 : 1);
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.track.scrollBy({ left, behavior: reducedMotion ? 'auto' : 'smooth' });
    }

    queueUpdate() {
      if (this.animationFrame) return;

      this.animationFrame = window.requestAnimationFrame(() => {
        this.animationFrame = null;
        this.updateControls();
      });
    }

    updateControls() {
      const maximum = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      const position = Math.abs(this.track.scrollLeft);
      const boundaryTolerance = 8;
      const hasOverflow = maximum > 2;
      const atStart = !hasOverflow || position <= boundaryTolerance;
      const atEnd = !hasOverflow || position >= maximum - boundaryTolerance;

      if (this.previousButton) this.previousButton.disabled = atStart;
      if (this.nextButton) this.nextButton.disabled = atEnd;
      this.toggleAttribute('data-at-start', atStart);
      this.toggleAttribute('data-at-end', atEnd);
    }
  }

  if (!customElements.get('rhd-scroll-rail')) {
    customElements.define('rhd-scroll-rail', RhdScrollRail);
  }
})();
